import { render } from "./MenuSearchBox.vue?vue&type=template&id=25f850bf"
import script from "./MenuSearchBox.vue?vue&type=script&lang=js"
export * from "./MenuSearchBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__